import {PropertiesPane} from '../components/NodePropertiesPane.jsx'
import ButtonExportModel from '../components/PropertiesPaneButtonExportModel.jsx'

export default function PropertiesPaneLs(props) {
    return (
        <PropertiesPane
            buttons={
                <>
                    <ButtonExportModel global type="ls" />
                    <ButtonExportModel global type="ls_excel" />
                </>
            }

            {...props}
        />
    )
}
